import React from 'react';
import { X } from 'lucide-react';
export function PainSection() {
  const pains = ['Te despiertas a las 3 AM con la mente acelerada', 'Cenas "saludable" pero amaneces hinchado/a', 'Tu metabolismo parece haberse detenido después de los 40', 'Te quedas dormido/a de cansancio, pero no descansas de verdad', 'Has probado suplementos y pastillas para dormir sin resultados duraderos', 'No sabes qué cenar que no te caiga pesado'];
  return <section className="w-full bg-ivory py-20 px-6" data-id="element-89">
      <div className="max-w-[720px] mx-auto text-center" data-id="element-90">
        <h2 className="font-serif text-3xl md:text-4xl text-botanic mb-12" data-id="element-91">
          ¿Te identificas con alguna de estas situaciones?
        </h2>

        <div className="flex flex-col gap-4 text-left mb-12" data-id="element-92">
          {pains.map((pain, i) => <div key={i} className="flex items-start gap-4 bg-white p-4 rounded-xl shadow-sm border border-alt-section" data-id="element-93">
              <X className="text-red-400 w-6 h-6 shrink-0 mt-0.5" data-id="element-94" />
              <span className="text-ink-soft text-lg" data-id="element-95">{pain}</span>
            </div>)}
        </div>

        <p className="font-serif text-lg md:text-xl text-ink leading-relaxed mb-10" data-id="element-96">
          "No es falta de voluntad. Es tu nuevo metabolismo. A partir de los 40
          años, tu cuerpo procesa la insulina de forma diferente al caer el sol.
          Una cena mal elegida dispara tu cortisol, bloquea la quema de grasa y
          te mantiene alerta cuando más necesitas descansar."
        </p>

        <p className="text-gold font-bold text-xl md:text-2xl" data-id="element-97">
          "La solución no está en una pastilla.
          <br data-id="element-98" />
          Está en tu plato."
        </p>
      </div>
    </section>;
}